module.exports = __webpack_public_path__ + "img/upload_file_purple.fbfd3e87.svg";